var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
/**
 * Simple error presentation
 */
var DefaultError = /** @class */ (function (_super) {
    __extends(DefaultError, _super);
    function DefaultError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultError.prototype.render = function () {
        return (React.createElement("sb-error-comp", null,
            React.createElement("h2", null, "Something went wrong."),
            React.createElement("details", { style: { whiteSpace: "pre-wrap" } },
                this.props.error && this.props.error.toString(),
                React.createElement("br", null),
                this.props.componentStack)));
    };
    return DefaultError;
}(React.Component));
export { DefaultError };
//# sourceMappingURL=DefaultError.js.map